import React from 'react';
import { convertInAlternativeCurrency } from '../../utils/convertInAlternativeCurrency';
import { getConfiguration } from '../../utils/configuration';
import { getCurrencySymbol } from '../../utils/getCurrencySymbol';
import { getPrintableAmount } from '../../utils/getPrintableAmount';
import { getLabel } from '../../../data/labels';

function Winnings(props) {
    const conf = getConfiguration();
    const currency = getCurrencySymbol(conf.cs.ct);
	const potWinAltCurr = convertInAlternativeCurrency(props.winnings && props.winnings > 0? props.winnings : props.potentialWinnings);
    if (props.status === 'losing') {
        return (
            <div className="winnings-box justify-content-center d-flex flex-column text-small | mb_5_3_1_1 lost">
                <span className="mb_5_3_1_1_1">{getLabel('mybets.perdente')}</span>
                <span className="text-medium bold | mb_5_3_1_1_2">
                	{`${getPrintableAmount(props.potentialWinnings, conf.cs.m, conf.cs.nd)} ${currency}`}
                	{potWinAltCurr && <span>{potWinAltCurr}</span> }
                </span>
            </div>
        );
    }

    return (
        <>
            {['paid', 'to_be_paid', 'winning', 'winning_cashback'].includes(props.status) ?
                <div className="winnings-box justify-content-center d-flex flex-column text-small | mb_5_3_1_1 won">
                    <span className="mb_5_3_1_1_1">{`${(props.status === 'winning_cashback' ? getLabel('mybets.winning_cashback') : getLabel('mybets.vincita'))}${props.paidWithCashout ? ` - ${getLabel('cashout.button_text')}` : ''}`}</span>
                    <span className="text-medium bold | mb_5_3_1_1_2">{`${getPrintableAmount(props.winnings && props.winnings > 0 ? props.winnings : props.potentialWinnings, conf.cs.m, conf.cs.nd)} ${currency}`}</span>
                	{potWinAltCurr && <span className="text-medium bold | mb_5_3_1_1_2">{potWinAltCurr}</span> }
                </div>
                :
                <div className="d-flex flex-column text-small | mb_5_3_1_1">
                    <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.vincitapotenziale')}</span>
                    <span className="text-medium bold | mb_5_3_1_1_2">
                    	{getPrintableAmount(props.potentialWinnings, conf.cs.m, conf.cs.nd)} {currency}
                		{potWinAltCurr && <span>{potWinAltCurr}</span> }
                	</span>
                </div>
            }
        </>
    );
}

export default Winnings;